<template>
    <h6 v-if="tabs.length == 0" class="properties-title">
        {{ $tr("Выберите файл или папку, чтобы увидеть подробные сведения о них.") }}</h6>
    <v-tabs v-model="tab" fixed-tabs>
        <v-tab v-for="(tab, index) in tabs" :key="index" :value="'tab' + index">{{ tab.title }}</v-tab>
    </v-tabs>
    <v-window v-model="tab">
        <v-window-item v-for="(tab, index) in tabs" :key="index" :value="'tab' + index" class="ma-2">
            <component :is="tab.component" :data="tab.data" />
        </v-window-item>
    </v-window>
</template>

<script>
export default {
    name: 'PropertiesBar',
    props: {
        title: String,
        tabs: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            tab: 'tab0',
        };
    },
};
</script>

<style scoped>
.properties-title {
    width: 100%;
    height:100%;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0px;
}
</style>
